import { render } from "./Switching.vue?vue&type=template&id=7d630894&scoped=true"
import script from "./Switching.vue?vue&type=script&lang=js"
export * from "./Switching.vue?vue&type=script&lang=js"

import "./Switching.vue?vue&type=style&index=0&id=7d630894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d630894"],['__file',"src/views/tcp/Switching.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d630894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d630894', __exports__)) {
    api.reload('7d630894', __exports__)
  }
  
  module.hot.accept("./Switching.vue?vue&type=template&id=7d630894&scoped=true", () => {
    api.rerender('7d630894', render)
  })

}


export default __exports__